<template>
    <div v-show="isModalVisible">
        <div class="modal-mask" @click="closeModal">
            <div class="modal-container" @click.stop>
                <!-- Modal Header -->
                <div class="modal-header">
                    <h6 class="modal-title">Edit Profile</h6>
                    <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
                </div>
                <!-- Modal body -->
                <div class="modal-body">
                    <div class="edit-profile-form">
                        <form @submit.prevent="onUpdate">
                            <div class="row margin-bottom-15">
                            <div class="col-12 col-sm-12">
                            <label
                                for="first_name"
                                class="col-12 input_label">First Name:<span class="required">*</span></label>
                            <input
                                type="first_name"
                                name="first_name"
                                class="col-12 col-sm-12 form-control"
                                ref="first_name"
                                v-validate="'required'"
                                v-model="first_name"
                                data-vv-as="First Name"
                                maxlength="180">
                            <div v-show="verrors.has('first_name')" class="validate-warning-msg">{{ verrors.first('first_name') }}</div>
                            </div>
                            </div>
                            <div class="row margin-bottom-15">
                            <div class="col-12 col-sm-12">
                            <label
                                for="last_name"
                                class="col-12 input_label">Last Name:<span class="required">*</span></label>
                            <input
                                type="last_name"
                                name="last_name"
                                class="col-12 col-sm-12 form-control"
                                ref="last_name"
                                v-validate="'required'"
                                v-model="last_name"
                                data-vv-as="Last Name"
                                maxlength="180">
                            <div v-show="verrors.has('last_name')" class="validate-warning-msg">{{ verrors.first('last_name') }}</div>
                            </div>
                            </div>
                            <div class="row margin-bottom-15" v-if="admin_flag === true && role_options != ''">
                            <div class="col-12 col-sm-12">
                                <label
                                    for="roles"
                                    class="col-12 input_label">Roles:<span class="required">*</span></label>
                                <div class="col-12 col-sm-12 chkboxwrapper" v-for="(option, key, index) in role_options">
                                <div v-if="index == 0">
                                    <input :value="key" type="checkbox"
                                    name="roles" v-model="roles"
                                    v-validate data-vv-rules="required" data-vv-as="Roles"
                                    :disabled="(is_mentee == 1 && ((key == 'ROLE_MENTOR') || (key == 'ROLE_INSTRUCTOR')))"
                                    >
                                    <label :for="option">{{ option }}</label>
                                </div>
                                <div v-else>
                                    <input :value="key" type="checkbox"
                                    name="roles" v-model="roles"
                                    :disabled="(is_mentee == 1 && ((key == 'ROLE_MENTOR') || (key == 'ROLE_INSTRUCTOR')))"
                                    >
                                    <label :for="option">{{ option }}</label>
                                </div>
                                </div>
                                <div v-show="verrors.has('roles')" class="validate-warning-msg">{{ verrors.first('roles') }}</div>
                            </div>
                            </div>
                            <div class="row margin-bottom-15" v-show="showGroupEdit">
                            <div class="col-12 col-sm-12" v-if="(isMenteeUserProfile && (!researcher_flag) && (!csr_flag))">
                                <label
                                    for="roles"
                                    class="col-12 input_label">Mentors : <span class="required">*</span></label>
                                <div class="col-12 col-sm-12 chkboxwrapper" v-for="(option, key, index) in groups_options">
                                <div v-if="key == 0">
                                    <input :value="option.id" :id="option.id" type="checkbox" name="mentors" v-model="groups" v-validate data-vv-rules="required">
                                    <label :for="option.groupName">{{ option.groupName }}</label>
                                </div>
                                <div v-else>
                                    <input :value="option.id" :id="option.id" type="checkbox" name="mentors" v-model="groups">
                                    <label :for="option.groupName">{{ option.groupName }}</label>
                                </div>
                                </div>
                                <div v-show="verrors.has('mentors')" class="validate-warning-msg">{{ verrors.first('mentors') }}</div>
                            </div>
                            <div class="col-12 col-sm-12" v-else-if="(!researcher_flag && !csr_flag)">
                                <label
                                    for="roles"
                                    class="col-12 input_label">Groups : <span class="required">*</span></label>
                                <div class="col-12 col-sm-12 chkboxwrapper" v-for="(option, key, index) in groups_options">
                                <div v-if="key == 0">
                                    <input :value="option.id" :id="option.id" type="checkbox" name="groups" v-model="groups" v-validate data-vv-rules="required">
                                    <label :for="option.groupName">{{ option.groupName }}</label>
                                </div>
                                <div v-else>
                                    <input :value="option.id" :id="option.id" type="checkbox" name="groups" v-model="groups">
                                    <label :for="option.groupName">{{ option.groupName }}</label>
                                </div>
                                </div>
                                <div v-show="verrors.has('groups')" class="validate-warning-msg">{{ verrors.first('groups') }}</div>
                            </div>
                            </div>
                            <div class="row margin-bottom-15">
                            <div class="col-12 col-sm-12">
                            <label
                                for="phone_number"
                                class="col-12 input_label">Phone Number: </label>
                            <input
                                type="phone_number"
                                name="phone_number"
                                class="col-12 col-sm-12 form-control"
                                ref="phone_number"
                                v-model="phone_number"
                                data-vv-as="Phone Number"
                                maxlength="20"
                                @keyup="phoneNumberFormat()"
                                @blur="phoneNumberFormat()"
                                v-validate="{ rules: { regex: phoneNumberValidRegex() } }">
                            <div v-show="verrors.has('phone_number')" class="validate-warning-msg">{{ verrors.first('phone_number') }}</div>
                            </div>
                            </div>
                            <div class="submit margin-bottom-15 text-center">
                            <button type="submit" class="btn btn-sm btn-blue submit_btn text-center">Save</button>
                            </div>
                            <div style="clear: both"></div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import { store } from '../store/store';
import axios from 'axios';
import {ValidationMethods} from './shared/common_validations.js';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
export default {
    mixins: [ValidationMethods],
    props: ['isModalVisible'],
    data() {
        return {
            first_name: '',
            last_name: '',
            phone_number: '',
            email: '',
            roles: [],
            role_options: [],
            groups: [],
            group_names: [],
            groups_options: [],
            showGroupEdit: false,
            notification_phone: false,
            email_display_flag: 'No',
            sms_display_flag: 'No',
            admin: false,
            masterAdmin: false,
            pageName: 'MY PROFILE',
            is_mentee: 0,
            showBackButton: false,
            loading: false,
            admin_flag: false,
            researcher_flag: false,
            csr_flag: false,
            get_url: '',
        }
    },
    methods: {
        navigate(pathUrl) {
            this.$router.push(pathUrl)
            this.$router.go();
        },
        getProfileUser() {
            var roles = this.$store.state.roles;
            if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
                this.masterAdmin = true;
            }
            if(roles.indexOf('ROLE_RESEARCHER') > -1) {
                this.researcher_flag = true;
            }
            if(roles.indexOf('ROLE_CSR') > -1) {
                this.csr_flag = true;
            }
            if(((roles.indexOf('ROLE_ADMIN') > -1) ||
            (this.$store.state.switch_admin_username)) &&
            ((this.$store.state.switch_flag != 'Instructor') &&
            (this.$store.state.switch_flag != 'Mentor'))
            ) {
                this.admin = true;
            }

            if(((roles.indexOf('ROLE_MENTOR') > -1) ||
            (roles.indexOf('ROLE_MENTEE') > -1) ||
            (roles.indexOf('ROLE_INSTRUCTOR') > -1) ||
            (roles.indexOf('ROLE_STUDENT') > -1)) &&
            ((this.$store.state.switch_flag != 'Manager') &&
            (this.$store.state.switch_flag != 'Primary Admin'))
            ) {
                this.showBackButton = true;
            }
            this.loading = true;
            document.body.className = 'profile-page';
            if(this.$route.params.user_id) {
                this.get_url = '/user-profile/' + this.$route.params.user_id;
                this.pageName = 'User Profile';
            }
            else {
                this.get_url = '/my-profile';
                this.pageName = 'My Profile';
            }
            var userAccountId = '';
            if(store.state.user_accountid) {
                userAccountId = store.state.user_accountid;
            }
            axios(this.get_url,
            {
                method: 'POST',
                data: {
                    "accountId": userAccountId,
                }
            }
            )
            .then(resp => {
                this.loading = false;
                for(var i=0; i < resp.data.user.groups.length; i++) {
                    this.groups.push(resp.data.user.groups[i].id);
                    this.group_names.push(resp.data.user.groups[i].name);
                }
                this.first_name = resp.data.user.first_name;
                this.last_name = resp.data.user.last_name;
                this.phone_number = resp.data.user.phone_number;
                this.email = resp.data.user.email;
                this.roles = resp.data.user.roles;
                this.role_options = resp.data.roleoptions;
                this.groups_options = resp.data.groupsoptions;
                this.admin_flag = resp.data.adminflag;
                this.is_mentee = resp.data.user.is_mentee;
                if(this.isMenteeProfile())
                {
                    this.userGroupRole = resp.data.user.userGroupRole;
                }
                this.showGroupEdit = this.checkUserMultipleGroupPermission();
            })
            .catch(error => {
            this.loading = false;
            })
        },
        isMenteeProfile() {
            if((this.roles.indexOf('ROLE_MENTEE') !='-1') || (this.roles.indexOf('ROLE_STUDENT') !='-1')) {
                return true;
            }
            else {
                return false;
            }
        },
        checkUserMultipleGroupPermission() {
            var loggedinUserRoles = store.state.roles;
            if((this.roles.indexOf('ROLE_MENTEE') !='-1' ||
                this.roles.indexOf('ROLE_INSTRUCTOR') !='-1' ||
                this.roles.indexOf('ROLE_STUDENT') !='-1' ) &&
                ((loggedinUserRoles.indexOf('ROLE_MENTEE') === -1) &&
                (loggedinUserRoles.indexOf('ROLE_STUDENT') === -1))) {
                return true;
            }
            else {
                return false;
            }
        },
        isMenteeUserProfile() {
            var userRoles = this.roles;
            if((userRoles.indexOf('ROLE_MENTEE') != '-1') || (userRoles.indexOf('ROLE_STUDENT') !='-1')) {
                if(this.userGroupRole == 'ROLE_MENTEE') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        },
        closeModal() {
            this.$validator.errors.clear();
            this.$emit('close');
        },
        onUpdate () {
            this.$validator.validateAll().then((result) => {
                if(!result){
                    return;
                }
                this.update();
            }).catch(() => {
                // catches the error;
            });
        },
        update: function () {
            var roles = this.$store.state.roles;
            if(roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) {
                this.update_url = '/enterprise-admin/my-profile';
            }
            else {
                this.update_url = '/my-profile';
            }
            var userAccountId = '';
            if(store.state.user_accountid) {
                userAccountId = store.state.user_accountid;
            }
            axios(this.update_url,
                {
                method: 'PATCH',
                data:  {
                            first_name: this.first_name,
                            last_name: this.last_name,
                            phone_number: this.phone_number,
                            roles: this.roles,
                            userGroups: this.groups,
                            accountId: userAccountId,
                        },
                }
            )
            .then((resp) => {
                this.flash({ message: 'Your profile is updated.', variant: 'success' });
                this.navigate("/myprofile");
            })
            .catch(error => {
                const fieldErrors =  [{}];
                    var errMsgObj = error.response.data.message;

                    Object.keys(errMsgObj).map(key => {
                    var newFieldErr = {field:key, msg:errMsgObj[key]};
                    fieldErrors.push(newFieldErr);
                    });
                    this.$validator.errors.add(fieldErrors);
            });
        },
    }
}
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
}
.edit-profile-form {
  font-size: 13px;  
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.input_label {
  font-weight: 900;
  padding: 0;
}
.input_label span {
  font-weight: normal;
}
.submit_btn {
  color: #FFF; 
  border-radius: 15px;
  font-weight: 900;
  width: 150px;
}
.task_name {
  font-size: 14px;
}
.custom_hr {
  border-bottom: 1px solid #00acee;
  margin: 10px 0px;
  width: 100%;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/edit_profile.vue